import React, { Fragment } from 'react';
import ScrollAnimation from '../../ScrollAnimation/ScrollAnimation';
import PictureImage from '../../UI/Image/Picture';
import { getImage, getNavigationPageLink, redirectUser } from '../../../utils';
import { GameListItem } from '../../../types/content';
import './GamesStyles.scss'
import { withContent } from '../../../hoc/withContext';
import { IContent } from '../../../types';

interface IGamesProps {
  countryCode : string;
  context? : IContent;
}

function blockClick(countryCode : string, block : GameListItem) {
  if(block.linkKey){
    let navigationLink = getNavigationPageLink(block.linkKey);
    redirectUser(navigationLink);
  }
}

const Games = ({ countryCode, context }: IGamesProps) => {
  return (
    <div className="wrapper-game-list">
      <div className="ubisoft-plus_container game-selection_inner show-game-list">
        <Fragment>
          {context.gamelist.list.map((block, index) => (
            <ScrollAnimation
              key={index}
              className={`${block.mobileOrder === undefined ? 'mobile-hide' : `order-${parseInt(block.mobileOrder)} mobile-flex`} image-wrapper game-text-border`}
              style={{ border: `3px solid ${block.color}`}}
              animateIn="slide-in"
              animatePreScroll={false}
            >
              {(block.text) ?
                <div
                  className={`${block.linkKey ? 'clickable-block' : ''} text-block`}
                  onClick={() => blockClick(countryCode,block)}>
                  <p
                    className={'text-block-text bolden-text'}
                    style={{ color: block.color }}>{block.description}</p>
                </div> :
                <PictureImage
                  images={getImage(block.image.link)}
                  extension="png"
                  altText={block.image.alt}
                  className={['']}
                />}
            </ScrollAnimation>
          ))}
        </Fragment>
      </div>
    </div>
  );
};

export default withContent(Games);